<template lang="pug">
#app
  v-container(grid-list-xl, fluid)
    v-layout(v-if="$root.user.permissao != 0", row, wrap)
      AccessLock
    v-layout(v-if="$root.user.permissao == 0", row, wrap)
      v-flex(lg12)
        v-card
          v-toolbar(card, color='white')
            v-text-field.hidden-sm-and-down(flat, solo, prepend-icon='search', placeholder='Buscar licença', v-model='search', hide-details)
            v-switch.mt-4(:false-value="0", :true-value="1", :color="filter.ativo ? 'success': ''", :label="filter.ativo ? 'Licenças ativas' : 'Licenças inativas'", v-model="filter.ativo")
            v-btn(:to="{ name: 'LicencaCadastro' }", color="bt-primary").white--text Cadastrar
          v-divider
          v-card-text.pa-1
            v-data-table(:headers='headers', :search='search', :items='list', :rows-per-page-items="[25,50,75,{text:'Todos','value':-1}]", :loading="loading").elevation-1
              template(slot='items', slot-scope='props')
                td.text-xs-left {{ props.item.nome }}
                td.text-xs-left {{ props.item.data_inicio | moment('DD/MM/YYYY') }}
                td.text-xs-right
                  v-tooltip(top)
                    v-btn(slot="activator", flat, icon, fab, dark, color='bt-primary', small, :to="{ name: 'LicencaEditar', params: { id: props.item.id } }")
                      v-icon edit
                    span Editar
                  v-tooltip(top)
                    v-btn(slot="activator", flat, icon, fab, dark, :color="props.item.ativo ? 'red' : 'warning'", small, @click="changeAtivo(props.item)")
                      v-icon {{ props.item.ativo ? 'delete' : 'restore' }}
                    span {{ props.item.ativo ? 'Desativar' : 'Ativar' }}
                  v-tooltip(top, v-if="!props.item.ativo")
                    v-btn(slot="activator", flat, icon, fab, dark, color="red", small, @click="remove(props.item)")
                      v-icon delete
                    span Excluir
</template>

<script>
import _ from 'lodash';
import AccessLock from '@/components/AccessLock';

export default {
  components: {
    AccessLock
  },
  data: () => ({
    filter: { ativo: 1 },
    licencas: [],
    headers: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Data de Início', align: 'left', value: 'data_inicio' },
      { text: 'Ações', align: 'right', sortable: false },
    ],
    search: '',
    loading: false
  }),
  computed: {
    list () {
      return _.filter(this.licencas, { ativo: this.filter.ativo });
    }
  },
  mounted () {
    this.getLicencas();
  },
  methods: {
    async getLicencas () {
      const vm = this;
      try {
        vm.loading = true;
        const response = await vm.$axios.get('/licenca');
        vm.licencas = response.data.rows;
        vm.loading = false;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os dados. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async changeAtivo (licenca) {
      const vm = this;
      try {
        const obj = _.cloneDeep(licenca);
        obj.ativo = obj.ativo ? 0 : 1;
        const response = await vm.$axios.put(`/licenca/${obj.id}`, obj);
        licenca.ativo = response.data.ativo;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: `Licença ${licenca.ativo ? 'ativada' : 'desativada'} com sucesso!` });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar a licença. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },
    async remove (licenca) {
      const vm = this;
      try {
        const res = await vm.$confirm('Deseja realmente excluir?<br> Essa ação não poderá ser desfeita!');
        if (!res) return;
        const response = await vm.$axios.delete(`/licenca/${licenca.id}`);
        vm.licencas = _.reject(vm.licencas, { id: licenca.id });
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Licença excluída com sucesso!' });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao excluir a licença. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },
  }
};
</script>

<style scoped>

</style>

